import React from "react";
import CircularProgress from "./CircularProgress";
const LoadingComponent = () => {
  return <CircularProgress />;
};

export default LoadingComponent;
